import getRequestAsPromise from './getRequestAsPromise.js';
var loadTranslationStrings = function(element, prefixPath, langCode, componentName, part, defaultValues) {
  defaultValues = defaultValues || {};
  return getRequestAsPromise('GET', prefixPath + '/i18n/' + langCode + '/' + componentName + '.json').then(function(response){
    var translationDict = JSON.parse(response);
    translationDict = (part)? translationDict[part] : translationDict;
    element.translationDict = Object.assign(translationDict, defaultValues);
    return element.translationDict;
  }, function(error){ 
    element.translationDict = defaultValues;
    return element.translationDict;
  });
}

export default loadTranslationStrings;